<carm-card *ngIf="whatsNew?.content">
  <carm-card-title>
    <span>{{'dashboard.widgets.whatsnew.title' | translate }}</span>
  </carm-card-title>
  <carm-card-content>
    <div [innerHtml]="whatsNew?.content"></div>
  </carm-card-content>
</carm-card>
